// eslint-no-undef
import React from 'react';
import Post from './Post';
import PostEditor from './PostEditor';
import SecurityMap from './SecurityMap';
import '../App.css';
import spinner from '../images/spinner.gif';

const maxDownvotes = 5;

export default class Timeline extends React.Component {

  constructor(props) {
    super(props);
    this.state = {posts: [], nextPage: 1, lastPage: -1, totalPosts: -1, isFetching: false}; 
  }

  handleScroll = (e) => {
    if ((e.target && e.target.id === 'notf') || !this.props.app.state.showTimeline) {
      e.preventDefault();
      return;
    }
    const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight,  html.scrollHeight, html.offsetHeight);
    const windowBottom = windowHeight + window.pageYOffset;
    if (windowBottom >= docHeight) {
      this.fetchPosts(this.props.category);
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.handleScroll);
    this.fetchPosts(this.props.category);
  }

  componentWillReceiveProps(newProps) {
    if (this.props.category !== newProps.category) {
      this.fetchPosts(newProps.category);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }


  refresh() {
    window.location = window.location.protocol + '//' + window.location.host;
  }

  async fetchPosts(cat) {
    let that = this;
    let posts = this.state.posts || [];
    if (this.state.isFetching) {
      return;
    }
    let nextPage = this.state.nextPage || 0;
    if (cat !== this.props.category) {
      window.scrollTo(0, 0);
      posts = [];
      nextPage = 1;
    } else if (this.state.totalPosts && posts.length === this.state.totalPosts) {
      this.setState({isFetching: false});
      return;
    }
    try {
      this.setState({isFetching: true});
      if (cat) {
        cat = `&post_category=${cat}`;
      }
      const d = await fetch(`/api/v1/posts?include_stats=true&include_comments=true&page=${nextPage}${cat || ''}`);
      d.json().then(data => {
        if (data) {
          let parsedBody = data;
          if (parsedBody && parsedBody['posts']) {
            posts = posts.concat(parsedBody['posts']);
            let totalPosts = parsedBody['meta']['total_posts'];
            that.setState({
              isFetching: false,
              posts: posts,
              nextPage: (nextPage + 1),
              lastPage: nextPage,
              totalPosts: totalPosts,
            });
          }
        } else {
          console.log('Got nothing: err is: ' + err);
        }   
      }); 
    } catch(e) {
      console.log('Post fetch unsuccessful.');
      console.log('Error is: ' + e);
      if ( e.statusCode && e.statusCode === 401) {
        // Show login page..
        console.log('  Got 401.. Need to login');
        this.refresh();
      }   
    }   
  }

  formatPosts() {
    let posts = [];
    if (this.state && this.state.posts) {
      for (let i = 0; i < this.state.posts.length; i++) {
        let badPost = 'no';
        if (this.state.posts[i].downvotes >= maxDownvotes || this.state.posts[i].flagged_by) {
          badPost = 'yes';
        }
        posts.push(<Post key={this.state.posts[i]._id['$oid']} app={this.props.app} current_user={this.props.user} data={this.state.posts[i]} badPost={badPost} />);
      }
    } else {
      posts.push('Timeline is empty...');
    }
    return posts;
  }

  render() {
    let cat = this.state.category || this.props.category;
    return (
      <div className='timeline'>
        <div className='timelineInner'>
          {(cat && cat === 'Segurança' ) ? <SecurityMap app={this.props.app} user={this.props.user} /> : ''}
          <PostEditor user={this.props.user} app={this.props.app} timeline={this} />
          {this.formatPosts()}
          {this.state.isFetching ? <img src={spinner} alt='' style={{display: 'block', height: '80px', marginLeft: '210px', marginBottom: '50px'}} /> : ''}
        </div>
      </div>
    );
  }

}
